import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

function Activities(){
    return(

        <>
        <Header/>

  {/*===== HERO AREA START =====*/}
  <div
    className="inner-hero"
    style={{ backgroundImage: "url(assets/img/bg/Ashok.jpg)" }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-8 m-auto text-center">
          <div className="inner-main-heading">
            <h1>Activities</h1>
            <div className="breadcrumbs-pages">
              {/* <ul>
                <li>
                  <a href="index.html">Home</a>
                </li>
                <li className="angle">
                  <i className="fa-solid fa-angle-right" />
                </li>
                <li>Activities</li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*===== HERO AREA START =====*/}

         {/*===== SERVICE AREA START =====*/}
  {/* <div className="service1 sp sp sec-bg2">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="heading2">
            <span
              className="sub-title"
              data-aos="zoom-in-left"
              data-aos-duration={900}
            >
              <img src="assets/img/icons/span3.svg" alt="" />
              WHAT WE DO{" "}
            </span>
            <h2 className="text-anime-style-3">
              Transforming Ideas into Impactful Results
            </h2>
            <p className="mt-16">
              At SEOX, we specialize in crafting innovative and tailored
              solutions to empower businesses across a wide range of industries.
              From nurturing startups and streamlining HR staffing to boosting
              digital presence through social media marketing and promoting
              sustainability with solar energy solutions, our expertise knows no
              bounds.{" "}
            </p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="overflow-hidden">
            <div className="service1-image image-anime reveal md:mt-30 sm:mt-30">
              <img src="assets/img/service/service1-image.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-30">
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={200}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>1</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">Startup Support</a>
              </h5>
              <p className="mt-16">
                From ideation to execution, we help new businesses take flight.
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={300}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>2</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">HR Staffing Excellence</a>
              </h5>
              <p className="mt-16">
                Providing top-tier staffing solutions to build winning teams.
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={400}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>3</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">Social Media Marketing</a>
              </h5>
              <p className="mt-16">
                Amplifying your digital presence with innovative strategies.
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={500}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>4</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">Solar Energy Solutions:</a>
              </h5>
              <p className="mt-16">
                Promoting sustainability through clean energy initiatives.
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={300}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>5</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">Real Estate Expertise</a>
              </h5>
              <p className="mt-16">
                Crafting compelling campaigns for property ventures
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={500}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>6</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">Advertising &amp; Branding</a>
              </h5>
              <p className="mt-16">
                Building brands that stand out in competitive markets."
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={500}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>7</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">E-Commerce Optimization</a>
              </h5>
              <p className="mt-16">
                From user-friendly platforms to targeted marketing,{" "}
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={500}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>8</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">travel Guide Expertise</a>
              </h5>
              <p className="mt-16">
                Embark on unforgettable journeys with our travel agency.
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
          data-aos-delay={500}
        >
          <div className="about-service-box mt-30">
            <div className="">
              <div className="num">
                <p>9</p>
              </div>
            </div>
            <div className="heading2">
              <h5>
                <a href="service-details.html">Insurance Policy</a>
              </h5>
              <p className="mt-16">
                Protect what matters most with comprehensive insurance solutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> */}
  {/*===== SERVICE AREA END =====*/}


   <div className="service15-section sp">
    <div className="container">
      {/* <div className="row align-items-center">
        <div className="col-lg-5">
          <div className="heading16">
            <h5 data-aos="fade-left" data-aos-duration={900}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={17}
                height={18}
                viewBox="0 0 17 18"
                fill="none"
              >
                <path
                  d="M8.49935 0.667969C8.81213 0.667969 9.12046 0.684913 9.42435 0.718802C9.53313 0.73084 9.63847 0.764185 9.73436 0.816934C9.83025 0.869684 9.91482 0.940803 9.98322 1.02623C10.0516 1.11166 10.1025 1.20973 10.133 1.31483C10.1635 1.41994 10.1731 1.53002 10.161 1.6388C10.149 1.74758 10.1156 1.85292 10.0629 1.94881C10.0101 2.04471 9.93901 2.12927 9.85358 2.19767C9.76815 2.26608 9.67009 2.31699 9.56498 2.34749C9.45988 2.378 9.34979 2.38751 9.24102 2.37547C7.86772 2.22184 6.48062 2.49875 5.27158 3.1679C4.06254 3.83706 3.09131 4.86538 2.49224 6.11063C1.89316 7.35589 1.69585 8.75653 1.92759 10.1188C2.15933 11.4811 2.80867 12.7377 3.7858 13.7149C4.76292 14.692 6.01954 15.3413 7.38183 15.5731C8.74412 15.8048 10.1448 15.6075 11.39 15.0084C12.6353 14.4093 13.6636 13.4381 14.3327 12.2291C15.0019 11.02 15.2788 9.63293 15.1252 8.25964C15.1131 8.15086 15.1227 8.04077 15.1532 7.93567C15.1837 7.83056 15.2346 7.7325 15.303 7.64707C15.4411 7.47453 15.6422 7.36395 15.8618 7.33964C16.0815 7.31532 16.3019 7.37928 16.4744 7.51743C16.5598 7.58584 16.631 7.6704 16.6837 7.76629C16.7365 7.86218 16.7698 7.96752 16.7818 8.0763C16.8152 8.38019 16.8321 8.68852 16.8327 9.0013C16.8327 13.6038 13.1018 17.3346 8.49935 17.3346C3.89685 17.3346 0.166016 13.6038 0.166016 9.0013C0.166016 4.3988 3.89685 0.667969 8.49935 0.667969ZM8.47268 5.56547C8.5276 5.77941 8.49534 6.00639 8.383 6.19656C8.27065 6.38672 8.0874 6.52451 7.87352 6.57964C7.28591 6.73356 6.77438 7.09603 6.43438 7.59939C6.09438 8.10276 5.94914 8.71264 6.02577 9.31522C6.10239 9.9178 6.39564 10.4719 6.8508 10.8742C7.30595 11.2764 7.89192 11.4993 8.49935 11.5013C9.05377 11.5015 9.59254 11.3175 10.0309 10.978C10.4693 10.6386 10.7824 10.1631 10.921 9.6263C10.9801 9.4166 11.1189 9.23836 11.3078 9.12978C11.4967 9.0212 11.7206 8.9909 11.9315 9.04538C12.1425 9.09986 12.3237 9.23478 12.4364 9.42125C12.549 9.60771 12.5842 9.83089 12.5343 10.043C12.2787 11.0229 11.675 11.8763 10.8361 12.4436C9.99724 13.011 8.98048 13.2535 7.97582 13.1259C6.97115 12.9983 6.0473 12.5093 5.37685 11.7502C4.70641 10.9912 4.33524 10.014 4.33268 9.0013C4.33254 8.07746 4.63943 7.17977 5.20511 6.44936C5.77079 5.71896 6.56318 5.19726 7.45768 4.9663C7.56367 4.93898 7.674 4.93281 7.78238 4.94814C7.89075 4.96347 7.99504 5 8.0893 5.05564C8.18355 5.11128 8.26592 5.18494 8.3317 5.27242C8.39748 5.35989 8.44539 5.45947 8.47268 5.56547ZM13.9193 0.773802C14.0715 0.836868 14.2015 0.943583 14.293 1.08048C14.3845 1.21737 14.4334 1.37831 14.4335 1.54297V3.06797H15.9577C16.1225 3.068 16.2836 3.1169 16.4206 3.20847C16.5576 3.30004 16.6644 3.43017 16.7274 3.58242C16.7905 3.73467 16.807 3.9022 16.7748 4.06383C16.7427 4.22546 16.6634 4.37393 16.5469 4.49047L13.5993 7.43464C13.4431 7.59093 13.2312 7.67876 13.0102 7.6788H10.9993L9.47602 9.20297C9.31965 9.35934 9.10757 9.44718 8.88643 9.44718C8.6653 9.44718 8.45322 9.35934 8.29685 9.20297C8.14048 9.0466 8.05264 8.83452 8.05264 8.61339C8.05264 8.39225 8.14048 8.18017 8.29685 8.0238L9.82102 6.5013V4.48964C9.82106 4.26864 9.90889 4.05671 10.0652 3.90047L13.011 0.953802C13.1276 0.837191 13.2761 0.757767 13.4377 0.725578C13.5994 0.693389 13.767 0.709881 13.9193 0.772969M12.7668 3.5538L11.4877 4.83464V6.01297H12.666L13.946 4.7338H13.6002C13.3792 4.7338 13.1672 4.646 13.0109 4.48972C12.8546 4.33344 12.7668 4.12148 12.7668 3.90047V3.5538Z"
                  fill="#120734"
                />
              </svg>{" "}
              Our Services
            </h5>
            <div className="space12" />
            <h2 className="text-anime-style-3">
              Tailored Solutions to Fuel Your Business Growth
            </h2>
          </div>
        </div>
        <div className="col-lg-4" />
        <div className="col-lg-3">
          <div className="btn-area1 text-end">
            <a href="service.html" className="theme-btn29">
              View More Services
            </a>
          </div>
        </div>
      </div> */}

  




      <div className="row mt-30">
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img1.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
philanthropy(Leprosy)              </h4>
              <div className="space16" />
<p>
 Leprosy chronic infectious disease affects skin, nerves. Caused by Mycobacterium leprae. Curable with multidrug therapy. Early detection, treatment reduce complications. Awareness campaigns, stigma reduction improve lives, ensure better social inclusion.
  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1000}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img2.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
                philanthropic(Disability)
              </h4>
              <div className="space16" />
              <p>Empowering individuals with disabilities to break barriers and achieve independence. We provide essential resources, advocate for equal rights, and build an inclusive world where every unique ability is valued.
 </p>
              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1100}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img3.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Philanthropic(Tribal)              </h4>
              <div className="space16" />
<p>
  "Tribal refers to people sharing ancestry, culture, often territory. Indigenous tribes keep unique traditions and strong land ties. Meaning varies, but supports recognizing distinct identities, heritage, rights, and community autonomy.
  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1200}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img4.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Philanthropic(Waste management)              </h4>
              <div className="space16" />
<p>
  Waste management involves collecting, recycling, disposing waste to reduce environmental harm. It includes source reduction, sustainable practices, public participation, protecting resources, improving community health, promoting cleaner environment for future generations.
  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
      </div>


       <div className="row mt-30">
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img1.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Citizens Movement (Meeting)
              </h4>
              <div className="space16" />
<p>
  
  Meetings are planned gatherings for discussing topics, sharing ideas, and decision-making. Effective meetings use clear agendas, encourage participation, support collaboration, stay focused, save time, and help achieve shared goals efficiently.
</p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1000}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img2.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Citizens Movement (Rallies)
              </h4>
              <div className="space16" />
<p>
 Rallies are organized public gatherings where people show support or opposition for a cause. Participants unite carrying signs, raising awareness, encouraging collective action for social, political, or environmental issues globally.

  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1100}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img3.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <a href="service-details1.html" className="title">
Agriculture(Dairy)
              </a>
              <div className="space16" />
<p>
 Dairy includes products made from milk, like milk, cheese, butter, yogurt. These provide essential nutrients such as calcium and protein, supporting strong bones, healthy growth, and important diets worldwide.

  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1200}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img4.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Agriculture(pisiculture)
              </h4>
              <div className="space16" />
<p>
  
  Pisciculture, also called fish farming or aquaculture, is controlled cultivation of fish. It includes breeding, rearing, harvesting in managed environments, supporting sustainable production, food security, livelihoods, and conservation efforts.
</p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
      </div>


















       <div className="row mt-30">
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img1.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Agriculture(organic farming)
              </h4>
              <div className="space16" />
<p>
 Organic farming is sustainable agriculture avoiding synthetic chemicals. It uses natural methods like composting, crop rotation, enhancing soil health, protecting environment, producing eco-friendly food often labeled organic in markets globally.
</p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1000}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img2.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
People's Movement(Slum Movement)
              </h4>
              <div className="space16" />
<p>
Slum movement involves organized efforts improving living conditions and rights in slums. Activists and residents address poverty, poor housing, limited amenities, promoting better infrastructure, services, inclusion, and empowering marginalized urban communities.

  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1100}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img3.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Innovations(Sieving Machine)
              </h4>
              <div className="space16" />
<p>
  A sieving machine separates particles by size using vibration or shaking. Material passes through a mesh, letting smaller particles through while larger ones stay. It supports efficient particle separation in industries.

  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1200}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img4.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
People's Movement(Flood Movement)
              </h4>
              <div className="space16" />
<p>
 Flood movement may refer to organized efforts addressing flood issues. It promotes prevention, preparedness, response, stronger infrastructure, early warnings, community awareness, and resilience to reduce damage, protect lives, and support recovery.

  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>




        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1200}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img4.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
People's Movement(Electricity)
              </h4>
              <div className="space16" />
<p>
Electricity is a versatile form of energy derived from charged particles. It powers homes, industries, and technology, generated through methods like fossil fuels and renewables, and distributed via electrical grids

  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>






        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1200}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img4.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Enterprises(Yubi Food)
              </h4>
              <div className="space16" />
<p>
Healthy food includes a variety of fruits, vegetables, whole grains, lean proteins, and healthy fats. A balanced diet with essential nutrients contributes to overall well-being, supporting optimal health and energy levels.

  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>






        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1200}
        >
          <div className="service15-boxarea">
            {/* <div className="img1">
              <img src="assets/img/service/service15-img4.png" alt="" />
            </div> */}
            <div className="space20" />
            <div className="content15-service">
              <h4 href="service-details1.html" className="title">
Enterprises(Manufacturing)
              </h4>
              <div className="space16" />
<p>
Manufacturing is the conversion of raw materials into finished goods through design, fabrication, assembly, and quality assurance. Advanced technologies and supply chain efficiency enhance productivity and innovation in modern manufacturing.

  </p>              <div className="space24" />
              {/* <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footer/>
        
        </>
    )
}

export default Activities;